import { render } from "./MailboxEdit.vue?vue&type=template&id=4e0475c8"
import script from "./MailboxEdit.vue?vue&type=script&lang=js"
export * from "./MailboxEdit.vue?vue&type=script&lang=js"
script.render = render

export default script